// extracted by css-extract-rspack-plugin
export default {"menu":"UserMenu_menu__Q+N-W"};